module.exports = __webpack_public_path__ + "img/suit-diamond.5c41f635.svg";